import React, { useEffect } from "react";
import { Spinner } from "reactstrap";

const Spinners = ({ setLoading, setWait = 1000 }) => {
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, setWait);
  }, [setLoading]);
  return (
    <React.Fragment>
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Spinner color="primary" />
      </div>
    </React.Fragment>
  );
};

export default Spinners;
